import { useMemo } from 'react';
import { isString } from 'lodash-es';
import { useGetUserCountries } from '@/api/queries/country/useGetUserCountries';
import { SelectItem } from '@/types/ui';
import { FILTER_CONFIG, FilterType, FilterValue, HCP_CHARACTERISTICS_FILTERS } from '@/models';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

/* This mapping was created to use the same formatters for all filters.
Filters in the network connection graph have different key namings, but we
would like to use the same formatters for all of them. */
export const EXTENDED_FILTER_CONFIG = {
  ...FILTER_CONFIG,
  ...HCP_CHARACTERISTICS_FILTERS,
};

const formatValue = (
  filterKey: FilterType | string,
  formatterOptions: {
    value: FilterValue;
    t: TFunction;
    contexts: { userCountries: SelectItem<string>[] };
  },
) => {
  const config = EXTENDED_FILTER_CONFIG[filterKey as FilterType];
  if (config?.format) return config.format(formatterOptions);
  return ((x: unknown) => (isString(x) ? x : JSON.stringify(x)))(formatterOptions.value);
};

const useFormattedGlobalFilterValue = ({
  filterKey,
  value,
}: {
  filterKey: FilterType | string;
  value: FilterValue;
}) => {
  const { t } = useTranslation();
  const { data: userCountries } = useGetUserCountries();

  const formatterContexts = useMemo(() => {
    return { userCountries: userCountries ?? [] };
  }, [userCountries]);

  const formattedValue = useMemo(() => {
    return formatValue(filterKey, { value, t, contexts: formatterContexts });
  }, [filterKey, value, t, formatterContexts]);

  return formattedValue;
};

export default useFormattedGlobalFilterValue;
